var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 61,
    viewBox: "0 0 100 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1074 19.2066C98.6475 18.6374 98.0334 18.172 97.3176 17.8506C96.6018 17.5291 95.8057 17.3611 94.9975 17.3608H26.6643L20.8944 5.4979C20.1379 3.93568 18.8568 2.60107 17.2137 1.66326C15.5705 0.72546 13.6392 0.226708 11.6647 0.230243H0V8.79553H11.6647L35.3841 57.5534C35.764 58.3335 36.4049 58.9999 37.2261 59.4686C38.0474 59.9373 39.0121 60.1873 39.9989 60.1873H79.9979C82.0828 60.1873 83.9478 59.0781 84.6828 57.4121L99.6824 23.151C99.9658 22.5027 100.062 21.8051 99.9615 21.1182C99.8613 20.4312 99.5683 19.7753 99.1074 19.2066ZM76.533 51.622H43.3339L30.8342 25.9261H87.7827L76.533 51.622Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store_icon.a821be55.svg";
export { ForwardRef as ReactComponent };